import {
  IconSettings,
  IconCoin,
  IconBusinessplan,
  IconPrinter,
  IconFileInvoice
} from '@tabler/icons';
import { Icon } from '@iconify/react';
import peopleFill from '@iconify/icons-eva/people-fill';

const icons = {
  IconSettings,
  IconCoin,
  IconBusinessplan,
  IconPrinter,
  IconFileInvoice
};

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const customermgmt = {
  id: 'pages',
  title: 'Loans & Customer',
  type: 'group',
  children: [
    {
      id: 'customer',
      title: 'Members',
      type: 'item',
      url: '/dashboard/client',
      icon: getIcon(peopleFill),
      breadcrumbs: false
    },
    {
      id: 'claims',
      title: 'Claims Management',
      type: 'collapse',
      icon: icons.IconCoin,
      children: [
        {
          id: 'processClaims',
          title: 'Process Claims',
          type: 'item',
          url: '/claims/selectBatch',
          target: false
        },
        {
          id: 'importsClaims',
          title: 'Import Claims',
          type: 'item',
          url: '/claims/claimsImport',
          target: false
        },
        {
          id: 'claimsSearch',
          title: 'Search Claims',
          type: 'item',
          url: '/claims/claimsSearch',
          target: false
        },
        {
          id: 'tariffsSearch',
          title: 'Search Tariffs',
          type: 'item',
          url: '/settings/tariffsSearch',
          target: false
        },
        {
          id: 'disburseFiles',
          title: 'Disbursement Files',
          type: 'item',
          url: '/claims/disbursementfiles',
          target: false
        },
        {
          id: 'fileLooksup',
          title: 'File Lookup View',
          type: 'item',
          url: '/ssb/filesinfo',
          target: false
        },
        {
          id: 'claimsOnline',
          title: 'Claims Online',
          type: 'item',
          url: '/claims/claimsonline',
          target: false
        }
      ]
    },
    {
      id: 'deps',
      title: 'Dependant Mngnt',
      type: 'collapse',
      icon: icons.IconCoin,
      children: [
        {
          id: 'addDeps',
          title: 'Add Dependants',
          type: 'item',
          url: '/clientportfolio/adddependant',
          breadcrumbs: false
        },
        {
          id: 'addDocs',
          title: 'Add Document',
          type: 'item',
          url: '/clientportfolio/adddocument',
          breadcrumbs: false
        },
        {
          id: 'depuplo',
          title: 'Upload Dependants',
          type: 'item',
          url: '/clientportfolio/dependantsupload',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'reportsnew',
      title: 'Reports - Claims',
      type: 'collapse',
      icon: icons.IconPrinter,
      children: [
        {
          id: 'providerSummary',
          title: 'Claims by Status..',
          type: 'item',
          url: '/reportsnew/providerSummary',
          breadcrumbs: false
        },
        {
          id: 'claimsSummaries',
          title: 'Claims by Type..',
          type: 'item',
          url: '/reportsnew/claimsSummary',
          breadcrumbs: false
        },
        {
          id: 'pmtSummary',
          title: 'Payments Summary',
          type: 'item',
          url: '/accounts/paymentsummary',
          target: false
        },
        {
          id: 'claimsStats',
          title: 'Claims Statistics',
          type: 'item',
          url: '/reportsnew/claimsstatistics',
          breadcrumbs: false
        },
        {
          id: 'nonAwards',
          title: 'Non Awarded Claims',
          type: 'item',
          url: '/reportsnew/nonawards',
          breadcrumbs: false
        },
        {
          id: 'retire',
          title: 'By Retirement',
          type: 'item',
          url: '/membershipreports/byretire',
          breadcrumbs: false
        },
        {
          id: 'memberBala',
          title: 'Actuarial Report',
          type: 'item',
          url: '/reports/actuarialReport',
          target: false
        }
      ]
    },
    {
      id: 'reports',
      title: 'Reports - Membership',
      type: 'collapse',
      icon: icons.IconPrinter,
      children: [
        {
          id: 'memberSummary',
          title: 'Member Summary',
          type: 'item',
          url: '/membershipreports/bysummary',
          target: false
        },
        {
          id: 'memberactive',
          title: 'Active Members Without Children',
          type: 'item',
          url: '/membershipreports/activewithoutkids',
          breadcrumbs: false
        },
        {
          id: 'memberactives',
          title: 'Active Members Without Spouse',
          type: 'item',
          url: '/membershipreports/activewithoutspouse',
          breadcrumbs: false
        },
        {
          id: 'memberprovince',
          title: 'Members By Province',
          type: 'item',
          url: '/membershipreports/byprovince',
          breadcrumbs: false
        },
        {
          id: 'memberdistrict',
          title: 'Members By District',
          type: 'item',
          url: '/membershipreports/bydistrict',
          breadcrumbs: false
        },
        {
          id: 'memberage',
          title: 'Members By Age',
          type: 'item',
          url: '/membershipreports/byage',
          breadcrumbs: false
        },
        {
          id: 'retire',
          title: 'By Retirement',
          type: 'item',
          url: '/membershipreports/byretire',
          breadcrumbs: false
        },
        {
          id: 'membership',
          title: 'Full Membership',
          type: 'item',
          url: '/reports/fullmembership',
          breadcrumbs: false
        },
        {
          id: 'memberchanges',
          title: 'Membership Changes',
          type: 'item',
          url: '/reports/membershipchanges',
          breadcrumbs: false
        },
        {
          id: 'defaults',
          title: 'Unpaid Subs',
          type: 'item',
          url: '/ssb/defaults',
          target: false
        },
        {
          id: 'membershipstats',
          title: 'Membership Stats',
          type: 'item',
          url: '/reports/membershipstats',
          breadcrumbs: false
        },
        {
          id: 'membershipagestats',
          title: 'Membership Age Stats',
          type: 'item',
          url: '/reports/membershipagestats',
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default customermgmt;
